<template>
  <footer class="bg-slate-200 min-h-12"></footer>
</template>
